import { connect } from "react-redux";
import ProjectItem from "./ProjectItem"

const mapStateToProps = state => ({
  tagList: state.tags.list
})

export default connect(mapStateToProps, null)(ProjectItem);